module.exports = __webpack_public_path__ + "static/img/portfolio_bg4.11c5cb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_bg-portfolio/portfolio_bg4.png
// module id = Jc3F
// module chunks = 1